class NewsText {
  constructor(params) {
    this.id = params.id;
    this.text = params.text;
    this.url = params.url;
    this.link = params.hyperlinkSubstring;
    this.startDate = params.startDate;
    this.endDate = params.endDate;
    this.language = params.language;
    return this;
  }
}
export { NewsText as default };
